<app-aggregated-amount-item
  [name]="(selectedArtist$ | async)?.nameMain"
  icon="./assets/stream_spotify.png"
  amount="{{ (spotifyFollower$ | async)?.units }}"
  unit="フォロワー数"
  [rate]="(spotifyFollower$ | async)?.rate"
  [link]="(spotifyFollower$ | async)?.url"
  [hasAmount]="(spotifyFollower$ | async)?.hasUnits"
  [loading]="loading$ | async"
  help="選択期間内に取得できた最新のSpotifyのアーティストフォロワー数を表示しています。"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
  [isDecimal]="true"
></app-aggregated-amount-item>
